import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { GN } from '../../gn';
import { DIC } from '../dic';
import * as moment from 'moment';

/**
 * Generated class for the ClinicPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-clinic',
  templateUrl: 'clinic.html',
})
export class ClinicPage {
  loading = false;
  allDevices = []
  allDevicesIds = []
  dimensions = []

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC) {

  }

  ionViewDidLoad() {
    var _that = this
    this.gn._Post('/api/gn/getclinicrooms', { cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      for (var i = 0; i < _data.length; i++) {
        //debugger
        _that.allDevicesIds.push(_data[i].id)

        _that.allDevices[_data[i].id] = []
        _that.allDevices[_data[i].id].room = _data[i].room
        _that.allDevices[_data[i].id].color = _data[i].color
        _that.allDevices[_data[i].id].push({ fullname: 'Марко Ивановски', code: '001', dt: moment('2020-04-12 09:30:20').format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat) })
        _that.allDevices[_data[i].id].push({ fullname: 'Никола Николов', code: '010', dt: moment('2020-04-12 09:33:24').format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat) })
        _that.allDevices[_data[i].id].push({ fullname: 'Ана Јовановска', code: '021', dt: moment('2020-04-12 09:37:28').format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat) })
        _that.allDevices[_data[i].id].push({ fullname: 'Иван Крстевски', code: '121', dt: moment('2020-04-12 10:37:29').format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat) })
        _that.allDevices[_data[i].id].push({ fullname: 'Јован Томовски', code: '099', dt: moment('2020-04-12 09:32:32').format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat) })
        _that.allDevices[_data[i].id].push({ fullname: 'Ненад Илиевски', code: '071', dt: moment('2020-04-12 09:39:45').format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat) })

        _that.allDevices[_data[i].id].push({ fullname: 'Теодор Петровски', code: '777', dt: moment('2020-04-12 09:39:45').format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat) })
        _that.allDevices[_data[i].id].push({ fullname: 'Александра Михајлова', code: '878', dt: moment('2020-04-12 09:39:45').format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat) })
        _that.allDevices[_data[i].id].push({ fullname: 'Мирјана Спасова', code: '910', dt: moment('2020-04-12 09:39:45').format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat) })
        _that.allDevices[_data[i].id].push({ fullname: 'Сања Илиева', code: '109', dt: moment('2020-04-12 10:39:45').format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat) })
        _that.allDevices[_data[i].id].push({ fullname: 'Дарко Иванов', code: '542', dt: moment('2020-04-12 11:39:45').format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat) })
        _that.allDevices[_data[i].id].push({ fullname: 'Петар Поповски', code: '956', dt: moment('2020-04-12 10:48:45').format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat) })
        _that.allDevices[_data[i].id].push({ fullname: 'Виолета Стојчевска', code: '843', dt: moment('2020-04-12 08:59:45').format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat) })


        _that.dimensions[_data[i].id] = []
        _that.dimensions[_data[i].id].push({ top: _data[i].toppos, left: _data[i].leftpos, width: _data[i].width, height: _data[i].height })

        if (i == _data.length - 1) {
          document.getElementById('kikiimg').style.maxHeight = (document.getElementById('kiki').offsetHeight - 40) + 'px'

          setTimeout(() => {
            document.getElementById('kikilist').style.width = (document.getElementById('kiki').offsetWidth - document.getElementById('kikiimg').offsetWidth) + 'px'
            // document.getElementById('borg').style.height = (document.getElementById('kikiimg').offsetHeight - 20) + 'px'
            // document.getElementById('borg').style.width = document.getElementById('kikiimg').offsetWidth + 'px'

            for (var i = 0; i < _that.allDevicesIds.length; i++) {
              //document.getElementById('dim' + _that.allDevicesIds[i]).style.left = 'calc(' + _that.dimensions[_that.allDevicesIds[i]][0].left + ' + ' + document.getElementById('kikilist').offsetWidth + 'px)'
              // document.getElementById('dim' + _that.allDevicesIds[i]).style.width = document.getElementById('kikiimg').offsetWidth * _that.dimensions[_that.allDevicesIds[i]][0].width / 100 + 'px';//'calc(' + _that.dimensions[_that.allDevicesIds[i]][0].width + ' - ' + document.getElementById('kikilist').offsetWidth + 'px)'

              debugger
              var _width = document.getElementById('kikiimg').offsetWidth * (_that.dimensions[_that.allDevicesIds[i]][0].width - 10) / 100
              var _height = document.getElementById('kikiimg').offsetHeight * (_that.dimensions[_that.allDevicesIds[i]][0].height - 15) / 100

              document.getElementById('dim' + _that.allDevicesIds[i]).style.top = ((_that.dimensions[_that.allDevicesIds[i]][0].top * document.getElementById('kikiimg').offsetHeight / 100) - _height / 2) + 'px'
              document.getElementById('dim' + _that.allDevicesIds[i]).style.left = ((_that.dimensions[_that.allDevicesIds[i]][0].left * document.getElementById('kikiimg').offsetWidth / 100) - _width / 2) + document.getElementById('kikilist').offsetWidth + 'px'

              debugger
              document.getElementById('dim' + _that.allDevicesIds[i]).style.width = _width + 'px'
              document.getElementById('dim' + _that.allDevicesIds[i]).style.height = _height + 'px'
              document.getElementById('dim' + _that.allDevicesIds[i]).style.maxHeight = _height + 'px'

            }
            _that.loading = true;
          }, 2000);
        }
      }



    })

    // this.allDevicesIds = [1001, 1002, 1003, 1004]

    // this.allDevices[1001] = []
    // this.allDevices[1001].room = 'А'
    // this.allDevices[1001].color = '#fad1d1'
    // this.allDevices[1001].push({ fullname: 'Марко Ивановски', code: '001', dt: moment('2020-04-12 09:30:20').format(this.gn.user.DFormat + ' ' + this.gn.user.TFormat) })
    // this.allDevices[1001].push({ fullname: 'Никола Николов', code: '010', dt: moment('2020-04-12 09:33:24').format(this.gn.user.DFormat + ' ' + this.gn.user.TFormat) })
    // this.allDevices[1001].push({ fullname: 'Ана Јовановска', code: '021', dt: moment('2020-04-12 09:37:28').format(this.gn.user.DFormat + ' ' + this.gn.user.TFormat) })
    // this.dimensions[1001] = []
    // // this.dimensions[1001].push({ top: '0%', left: '0%', height: '49%', width: '36%' })
    // this.dimensions[1001].push({ top: 'calc(26% - 100px)', left: 'calc(19% - 100px)' })

    // this.allDevices[1002] = []
    // this.allDevices[1002].room = 'Б'
    // this.allDevices[1002].color = '#c5dbc5'
    // this.allDevices[1002].push({ fullname: 'Марија Спасовска', code: '041', dt: moment('2020-04-12 09:30:20').format(this.gn.user.DFormat + ' ' + this.gn.user.TFormat) })
    // this.allDevices[1002].push({ fullname: 'Александар Николовски', code: '013', dt: moment('2020-04-12 09:33:24').format(this.gn.user.DFormat + ' ' + this.gn.user.TFormat) })
    // this.allDevices[1002].push({ fullname: 'Иван Крстевски', code: '201', dt: moment('2020-04-12 09:37:28').format(this.gn.user.DFormat + ' ' + this.gn.user.TFormat) })
    // this.allDevices[1002].push({ fullname: 'Јован Томовски', code: '317', dt: moment('2020-04-12 09:37:28').format(this.gn.user.DFormat + ' ' + this.gn.user.TFormat) })
    // this.dimensions[1002] = []
    // // this.dimensions[1002].push({ top: '0%', left: '43%', height: '39%', width: '39%' })
    // this.dimensions[1002].push({ top: 'calc(20% - 100px)', left: 'calc(59% - 100px)' })

    // this.allDevices[1003] = []
    // this.allDevices[1003].room = 'В'
    // this.allDevices[1003].color = '#f1f1c2'
    // this.allDevices[1003].push({ fullname: 'Виолета Стојчевска', code: '556', dt: moment('2020-04-12 09:30:20').format(this.gn.user.DFormat + ' ' + this.gn.user.TFormat) })
    // this.allDevices[1003].push({ fullname: 'Петар Поповски', code: '778', dt: moment('2020-04-12 09:33:24').format(this.gn.user.DFormat + ' ' + this.gn.user.TFormat) })
    // this.allDevices[1003].push({ fullname: 'Теодор Петровски', code: '223', dt: moment('2020-04-12 09:37:28').format(this.gn.user.DFormat + ' ' + this.gn.user.TFormat) })
    // this.allDevices[1003].push({ fullname: 'Дарко Иванов', code: '007', dt: moment('2020-04-12 09:37:28').format(this.gn.user.DFormat + ' ' + this.gn.user.TFormat) })
    // this.allDevices[1003].push({ fullname: 'Сања Илиева', code: '049', dt: moment('2020-04-12 09:37:28').format(this.gn.user.DFormat + ' ' + this.gn.user.TFormat) })
    // this.dimensions[1003] = []
    // // this.dimensions[1003].push({ top: '52%', left: '0%', height: '44%', width: '47%' })
    // this.dimensions[1003].push({ top: 'calc(75% - 100px)', left: 'calc(24% - 100px)' })

    // this.allDevices[1004] = []
    // this.allDevices[1004].room = 'Г'
    // this.allDevices[1004].color = '#b9b9f0'
    // this.allDevices[1004].push({ fullname: 'Александра Михајлова', code: '178', dt: moment('2020-04-12 09:30:20').format(this.gn.user.DFormat + ' ' + this.gn.user.TFormat) })
    // this.allDevices[1004].push({ fullname: 'Ненад Илиевски', code: '094', dt: moment('2020-04-12 09:33:24').format(this.gn.user.DFormat + ' ' + this.gn.user.TFormat) })
    // this.allDevices[1004].push({ fullname: 'Нада Попова', code: '036', dt: moment('2020-04-12 09:37:28').format(this.gn.user.DFormat + ' ' + this.gn.user.TFormat) })
    // this.dimensions[1004] = []
    // // this.dimensions[1004].push({ top: '39%', left: '48%', height: '50%', width: '10%' })
    // this.dimensions[1004].push({ top: 'calc(74% - 100px)', left: 'calc(63% - 100px)' })




  }

}



// WEBPACK FOOTER //
// ./src/pages/clinic/clinic.ts